import { createFileRoute } from "@tanstack/react-router";
import ContactUs from "@/pages/ContactUs";
import { buildHead } from "@/lib/seo";

export const Route = createFileRoute("/contact")({
  head: () =>
    buildHead({
      title:
        "Contact Us | Free Estimate | Precision Pavers & Pool Design | Broward County, FL",
      description:
        "Get a free estimate for pool remodeling, deck resurfacing, driveway pavers, and outdoor enhancements. Call +1 954-200-3501 or visit our Pompano Beach showroom. Serving Fort Lauderdale, Coral Springs, and all of Broward County.",
      path: "/contact",
      jsonLd: {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://precisionpaverspools.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Contact Us",
            item: "https://precisionpaverspools.com/contact",
          },
        ],
      },
    }),
  component: ContactUs,
});
